// extracted by mini-css-extract-plugin
export default {"price":"J8-z","onSale":"K8-z","msrpLabelPrice":"L8-z","msrpLabel":"M8-z","originalPrice":"N8-z","percentOff":"O8-z"};